import { api } from '@/lib/api';
import type { ApiNotification } from '@/lib/types';

export async function getNotifications(): Promise<ApiNotification[]> {
  const result = await api<ApiNotification[] | { items?: ApiNotification[]; data?: ApiNotification[] }>('/notifications');
  if (Array.isArray(result)) return result;
  if (result && 'items' in result && result.items) return result.items;
  if (result && 'data' in result && result.data) return result.data;
  return [];
}

export async function getUnreadCount(): Promise<number> {
  const result = await api<{ count: number } | number>('/notifications/unread-count');
  if (typeof result === 'number') return result;
  if (result && typeof result === 'object' && 'count' in result) return (result as { count: number }).count;
  return 0;
}

export async function markNotificationRead(id: string): Promise<void> {
  return api<void>(`/notifications/${id}/read`, { method: 'PATCH' });
}

export async function markAllNotificationsRead(): Promise<void> {
  return api<void>('/notifications/read-all', { method: 'PATCH' });
}